import Box from '@mui/material/Box';

import { CloverPaymentInformation } from 'payments/components/clover/CloverPaymentInformation';
import { CommerceHubPaymentInformation } from 'payments/components/commerceHub/CommerceHubPaymentInformation';
import { StripePaymentInformation } from 'payments/components/stripe/StripePaymentInformation';
import { PaymentProviders } from 'payments/constants/providers';
import { usePaymentProvider } from 'payments/hooks/usePayments';
import { PaymentInformationProps } from 'reservations/payments/types';

export const PaymentInformation = ({
  bookingDate,
  children
}: React.PropsWithChildren<PaymentInformationProps>) => {
  let PaymentInformation;
  const paymentProvider = usePaymentProvider();

  switch (paymentProvider) {
    case PaymentProviders.CLOVER:
      PaymentInformation = CloverPaymentInformation;
      break;
    case PaymentProviders.COMMERCE_HUB:
      PaymentInformation = CommerceHubPaymentInformation;
      break;
    case PaymentProviders.STRIPE:
      PaymentInformation = StripePaymentInformation;
      break;
    default:
      return <>{children}</>;
  }
  return (
    <Box>
      <PaymentInformation bookingDate={bookingDate}>
        {children}
      </PaymentInformation>
    </Box>
  );
};
